import { createApi } from '../axios'
import { baseURL } from '../config'

function responseHandle (res) {
  let msg = ''
  if (!res.data) {
    msg = res.status
    throw new Error(msg)
  } else if (res.data.ret !== 0) {
    msg = res.data.ret + ' ' + res.data.msg
    throw new Error(msg)
  }

  return res.data
}

export default createApi(responseHandle, {
  getChannels (params) {
    return {
      url: '/api/v1/hlwmp/get_channels',
      method: 'get',
      baseURL: baseURL
    }
  },
  getOrderList (params) {
    return {
      url: '/api/v1/hlwmp/get_orderinfo',
      method: 'post',
      data: params,
      baseURL: baseURL
    }
  },
  getOrderInfo (params) {
    return {
      url: '/api/v1/hlwmp/get_resinfo',
      method: 'GET',
      params: params
    }
  }
})
